export default __webpack_public_path__ + "static/media/pipelines-suppress.3e5c1ea4.svg";